import React from 'react';
import styles from '../styles/Header.module.css';

/**
 * アプリケーションのヘッダーコンポーネント
 */
const Header = () => {
  return (
    <div className={styles.header}>
      <h1 className={styles.appTitle}>年号・和暦計算</h1>
      <p className={styles.subtitle}>西暦と和暦を簡単に変換できるツール</p>
    </div>
  );
};

export default Header; 